module.exports = require('./pop')


// WEBPACK FOOTER //
// ./~/fe-pop/src/index.js